import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "facet-search-dropdown" }
const _hoisted_2 = {
  divider: "",
  class: "facet-search-dropdown__controls"
}



import Spinner from "@/components/px-spinner/px-spinner.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'facet-search-dropdown',
  props: {
    title: {},
    query: {},
    loading: { type: Boolean },
    options: {},
    hasSearch: { type: Boolean },
    searchPlaceholder: {}
  },
  emits: ["updateQuery"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const updateQuery = (value: string) => {
  // @ts-expect-error fix type
  emit("update-query", value);
};

const clearAllFilters = () => {
  // @ts-expect-error fix type
  emit("clear-all-filters");
};

return (_ctx: any,_cache: any) => {
  const _component_ElTag = _resolveComponent("ElTag")!
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")!
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")!
  const _component_ElDropdown = _resolveComponent("ElDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ElDropdown, {
      placement: "bottom-start",
      "hide-on-click": false
    }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_ElDropdownMenu, null, {
          default: _withCtx(() => [
            (props.hasSearch)
              ? (_openBlock(), _createBlock(_component_ElInput, {
                  key: 0,
                  clearable: "",
                  class: "facet-search-dropdown__input",
                  "model-value": props.query,
                  placeholder: props.searchPlaceholder,
                  onInput: updateQuery
                }, null, 8, ["model-value", "placeholder"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
              return (_openBlock(), _createBlock(_component_ElDropdownItem, {
                key: option.props.value
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(option.component), _mergeProps({ ref_for: true }, option.props, _toHandlers(option.listeners)), null, 16))
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createElementVNode("div", _hoisted_2, [
              (props.loading)
                ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(_component_ElTag, {
                type: "danger",
                onClick: clearAllFilters
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("Clear All", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_ElTag, {
          type: "primary",
          effect: "plain"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.title), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})